import { Input } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../i18n/prefix';

const CREDENTIAL_I18N = 'components:credential_field' satisfies I18nPrefix;

/**
 * A secret-valued input. Stored credentials never come back from the API, so once one is
 * saved the field masks itself and a blank value means "keep it" rather than "clear it".
 */
export function CredentialField({
  name,
  label,
  placeholder,
  value,
  onChange,
  hasStoredValue,
  error,
  type = 'password',
  tooltip,
}: {
  name?: string;
  label: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  /** Flips the label and placeholder to their "update" form. */
  hasStoredValue: boolean;
  error?: string;
  type?: 'text' | 'password';
  tooltip?: string;
}) {
  const displayLabel = t(
    hasStoredValue ? `${CREDENTIAL_I18N}.update` : `${CREDENTIAL_I18N}.enter`,
    { label },
  );
  const displayPlaceholder = hasStoredValue
    ? t(`${CREDENTIAL_I18N}.masked_placeholder`)
    : placeholder;

  return (
    <Input
      name={name}
      type={type}
      label={displayLabel}
      placeholder={displayPlaceholder}
      value={value}
      onChange={onChange}
      error={error}
      tooltip={tooltip}
      autoComplete="new-password"
    />
  );
}
